export default __webpack_public_path__ + "./images/kp.c8977021.png";